import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isSuccessResponse } = {}) => ({
  centered: { textAlign: 'center' },
  container: {
    alignItems: 'center',
    display: 'flex',
    height: 'calc(100vh - 250px)',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    width: 600,
    [theme.breakpoints.down('lg')]: {
      width: 600,
    },
    [theme.breakpoints.down('md')]: {
      width: 230,
    },
  },
  icon: {
    alignItems: 'center',
    background: '#F4F4F4',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    height: 120,
    width: 120,
    '& svg': {
      cursor: 'initial',
      ...(!isSuccessResponse && {
        height: 70,
        width: 70,
      }),
    },
  },
  infoMessage: {
    fontSize: '18px',
    letterSpacing: '0.2px',
    lineHeight: '22px',
    paddingTop: theme.spacing(0.75),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      letterSpacing: '0.1px',
      lineHeight: '16px',
    },
  },
}));
